const Lang = {
  noServerSideRenderingYet: 'No server-side rendering yet',
  replacementParagraph: 'The woods are lovely, dark and deep, but I have promises to keep and and miles to go before I sleep.',
  noDocumentationAvailable: 'No documentation available for this view.',
  documentationAndApi: 'Documentation and API',
  uiComponents: 'Desktop and Mobile UI Components',
  directives: 'Useful Directives',
  formElements: 'Advanced Form Elements',
  gettingStarted: 'Getting Started',
  layout: 'Layout Strategies',
  stylesAndColors: 'Styles & Colors'
}

export default Lang



// WEBPACK FOOTER //
// ./src/helpers/lang.js